import { createAction, props } from '@ngrx/store';
import { IpsecCertificate } from './ipsec-certificate.interface';

export const setIpsecCertificateAction = createAction(
  '[Ipsec certificate] set',
  props<{ certificates: IpsecCertificate[] }>()
);

export const clearIpsecCertificateAction = createAction('[Ipsec certificate] clear');
